import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "unlockViewSettings"
};
const _hoisted_2 = {
  class: "unlockViewHeader"
};
const _hoisted_3 = {
  class: "unlockViewHTitle"
};
const _hoisted_4 = {
  class: "unlockViewHInfo"
};
const _hoisted_5 = {
  class: "unlockViewContent"
};
const _hoisted_6 = {
  class: "unlockViewForm"
};
const _hoisted_7 = {
  class: "unlockViewFormToggle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_toggle = _resolveComponent("w-toggle");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('speach.metadata.unlockView.title')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('speach.metadata.unlockView.info')), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_w_toggle, {
    value: _ctx.lockedSubchapters,
    onChange: _ctx.changeLockedSubchapters
  }, null, 8, ["value", "onChange"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('speach.metadata.unlockView.message')), 1)])])])], 64);
}